var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useClient, useClients } from "../selectors";
export var ClientsAutocomplete = function (_a) {
    var _b, _c, _d;
    var clientId = _a.value, label = _a.label, onChange = _a.onChange;
    var _e = React.useState(false), isOpen = _e[0], setOpen = _e[1];
    var _f = useClients({}), data = _f.data, isLoading = _f.isLoading;
    var selectedClient = useClient(clientId);
    var value = (_c = (_b = data === null || data === void 0 ? void 0 : data.items.find(function (client) { return client.id === clientId; })) !== null && _b !== void 0 ? _b : selectedClient.data) !== null && _c !== void 0 ? _c : null;
    var options = value && data && !data.items.some(function (client) { return client.id === value.id; })
        ? __spreadArray([value], data.items) : (_d = data === null || data === void 0 ? void 0 : data.items) !== null && _d !== void 0 ? _d : [];
    return (React.createElement(Autocomplete, { open: isOpen, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, getOptionSelected: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { var _a, _b, _c, _d; return (_d = (_b = (_a = option.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = option.user) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : ""; }, options: options, loading: isLoading || selectedClient.isLoading, noOptionsText: "Не найдено ни одного клиента", loadingText: "Поиск...", value: value, fullWidth: true, onChange: function (_, user) {
            onChange(user);
        }, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: label, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                    (isLoading || selectedClient.isLoading) && (React.createElement(CircularProgress, { color: "inherit", size: 20 })),
                    params.InputProps.endAdornment)) }) }))); } }));
};
